/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import IconX from '../Icons/IconX';

interface Props {
  title: string;
  textHTMLContent: string;
  textCentered: boolean;
  acceptButtonTextKey: string;
  cancelButtonTextKey?: string;
  showModal: boolean;
  isBig: boolean;
  isOro?: boolean;
  isSmall: boolean;
  setShowModal: (visible: boolean) => void;
  doAceptar: () => void;
  doClose: () => void;
  hideXButton?: boolean;
  showCancel: boolean;
  event_hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
}

const ModalContactConfirmacion: FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    doAceptar,
    doClose,
    title,
    textHTMLContent,
    textCentered,
    showModal,
    setShowModal,
    isBig,
    cancelButtonTextKey,
    isOro,
    isSmall,
    acceptButtonTextKey,
    hideXButton,
    showCancel,
    event_hittype,
    event_category,
    event_action,
    event_label,
  } = props;

  const hideModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(false);
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      hideModal(e);
      doAceptar();
      window.removeEventListener('keydown', saveInfo, false);
    }
  };

  useEffect(() => {
    const element = document.querySelector(
      '#modal-confirmacion.is-active',
    ) as HTMLElement;

    if (showModal && element) {
      window.addEventListener('keydown', saveInfo, false);
      window.focus();
    } else {
      window.removeEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  return (
    <div
      className={`modal ${
        isBig ? 'modal--large' : isSmall ? 'modal--small' : 'modal'
      } ${showModal ? 'is-active' : ''}`}
      id="modal-confirmacion"
    >
      <div className="modal__background" />
      <div className="modal__card u-text-center">
        <header className="modal__card-head u-flex">
          <div
            className={isOro ? 'modal__card-title-oro' : 'modal__card-title'}
          >
            {title}
          </div>
          {(() => {
            if (
              hideXButton === null ||
              hideXButton === undefined ||
              !hideXButton
            ) {
              return (
                <a
                  className="modal__card-close modal-cerrar"
                  onClick={(e: any) => {
                    hideModal(e);
                    doClose();
                  }}
                >
                  <span className="hidden">Icono para cerrar modal</span>
                  <div className="icon icon-medium icon--close">
                    <IconX classCss="" />
                  </div>
                </a>
              );
            }
            return false;
          })()}
        </header>
        <div className="modal__card-body">
          <fieldset>
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label u-text-left u-full-width u-margin-bottom">
                <p
                  className={textCentered ? 'u-text-center' : ''}
                  dangerouslySetInnerHTML={{
                    __html: textHTMLContent,
                  }}
                />
              </label>
              <div className="modal__botonera">
                {(() => {
                  if (showCancel) {
                    return (
                      <>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <a
                          className="btn btn-secundary link_button u-margin-bottom-small"
                          data-wa-hittype={event_hittype}
                          data-wa-event-category={event_category}
                          data-wa-event-action={event_action}
                          data-wa-event-label={event_label}
                          onClick={(e: any) => {
                            hideModal(e);
                            doAceptar();
                          }}
                        >
                          {t(acceptButtonTextKey)}
                        </a>
                      </>
                    );
                  }
                  return false;
                })()}
                <button
                  id="confirm-email-btn"
                  type="button"
                  onClick={(e: any) => {
                    hideModal(e);
                    doClose();
                  }}
                  className="btn btn-primary u-margin-bottom-small"
                >
                  {showCancel && cancelButtonTextKey
                    ? t(cancelButtonTextKey)
                    : t('entendido')}
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default ModalContactConfirmacion;
